import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-transfer-list',
  templateUrl: './stock-transfer-list.component.html',
  styleUrls: ['./stock-transfer-list.component.css']
})
export class StockTransferListComponent implements OnInit {

  private dp = [];
  report_result = {};

  displayedColumns = ['sub_item_no', 'main_item_name', 'item_subcat_name', 'unit_name', 'from_store', 
    'to_store', 'transfer_quantity', 'transfer_date', 'print'];   // 'stock_no', 

  displayedColumns1 = ['sub_item_no', 'main_item_name', 'item_subcat_name', 'unit_name', 'from_store', 
    'to_store', 'transfer_quantity', 'transfer_date'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'type': 'transfer_list', 'title': 'قائمة التحويل' };

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  Transfer_List;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Transfer_List').subscribe((res: string) => {
      this.Transfer_List = res;
    });
    this.model['title'] = this.Transfer_List;
  }

  ngOnInit() {
  }

  onChangeRepResult = function (report_result: object) {
    console.log(report_result);
    this.report_result = report_result;

    this.dp = this.report_result['list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  print_statement(row) {
    window.open(this.applicationConstants.generatePDF + "?store_id=" + row.store_id + 
      "&sub_item_number=" + row.sub_item_number + "&stock_date=" + row.stock_date, "_blank");
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td> ' + this.Transfer_List + '</td>';
    html_data += '</tr></table>';

    let table = (document.getElementById('trans_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
